import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "circle-check-fill",
  "use": "circle-check-fill-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"circle-check-fill\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 16A8 8 0 118 0a8 8 0 010 16zm-1.248-4.027L3.735 8.956C2.67 7.889 4.177 6.38 5.244 7.447l1.553 1.554L10.57 5.23a1.039 1.039 0 011.463 1.463l-5.28 5.28z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol